import React, { useState } from 'react'

import SwiperCore from 'swiper'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import { ArticleClientType } from 'src/strapi/types/articleTypes'

import { ArticleBrowseContent } from './ArticleBrowseContent/ArticleBrowseContent'
import { ArticleBrowseTitle } from './ArticleBrowseTitle/ArticleBrowseTitle'

export type ArticleBrowseOtherProps = {
  articles: Array<ArticleClientType>
}

export const ArticleBrowseOther: React.FC<ArticleBrowseOtherProps> = ({
  articles,
}) => {
  const [swiper, setSwiper] = useState<SwiperCore | null>(null)

  const handleSlideNext = () => {
    swiper?.slideNext()
  }

  const handleSlidePrev = () => {
    swiper?.slidePrev()
  }

  return (
    <ContentSection className="container">
      <ArticleBrowseTitle onNext={handleSlideNext} onPrev={handleSlidePrev} />
      <ArticleBrowseContent articles={articles} onSwiper={setSwiper} />
    </ContentSection>
  )
}
